<ab-loader [showLoader]="(!transfer && !accounts) || isLoading"></ab-loader>

<ng-container *ngIf="transfer">
  <div class="container">
    <div class="panel">
      <ng-container *ngIf="challengeCodeError">
        <div class="alert label-login-qr alert-danger">
          {{ challengeCodeErrorMessage }}
        </div>
      </ng-container>
      <div class="payment-transfer">
        <div class="title">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="32" viewBox="0 0 20 32" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M1.1482 12.2525C-0.382732 10.7277 -0.382732 8.23471 1.1482 6.70988L6.75648 1.12341C8.26001 -0.37447 10.6782 -0.37447 12.1817 1.12341L12.2512 1.19283C13.7878 2.72339 13.8128 5.07484 12.1931 6.70886L6.71238 12.2525C5.17578 13.7831 2.6848 13.7831 1.1482 12.2525Z"
              fill="#00698F" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.90808 30.8187C6.34948 29.2441 6.34948 26.6903 7.90808 25.116L13.1872 19.7805C14.7458 18.2059 17.2727 18.2059 18.8313 19.7805C20.3896 21.3556 20.3896 23.909 18.8313 25.484L13.5518 30.8187C11.9935 32.3938 9.46635 32.3938 7.90808 30.8187Z"
              fill="#00698F" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M2.63945 23.42L2.62106 23.4014C1.05868 21.8229 1.05868 19.2633 2.62106 17.6845L11.7031 8.50678C13.2655 6.92795 15.7984 6.92795 17.3608 8.50678L17.3792 8.52536C18.9412 10.1042 18.9412 12.6635 17.3792 14.2423L8.29716 23.42C6.73478 24.9988 4.20182 24.9988 2.63945 23.42Z"
              fill="#00698F" />
          </svg>
          <h1 class="heading-primary">Sentoo payment</h1>
        </div>
        <div class="store-amount">
          <h2 class="fs-24 text-primary font-weight-bold">Webshop</h2>
          <span class="amount">{{transfer?.currency | abCurrencySymbol }} <span
              [innerHTML]="transfer?.amount | supFraction"></span></span>
        </div>
        <div class="fromAccount">
          <label>From</label>
          <div class="account-selector"  (click)="toggleAccountList()">
            <div class="account-info" >
              <span class="account-name">{{
                selectedAccount?.alias ||
                selectedAccount?.description ||
                selectedAccount?.accountName
                }}</span>
              <span class="portfolio-name">{{ selectedAccount?.portfolioName }}</span>
              <span class="account-number" disabled>{{ selectedAccount?.accountNumber }}</span>
              <span class="account-owner">{{ selectedAccount?.accountOwner }}</span>
            </div>

            <div class="text-right">
              <div class="balance" *ngIf="selectedAccount?.accountBalance !== undefined">
                {{ selectedAccount?.accountCurrency | abCurrencySymbol }}
                <span [innerHTML]="selectedAccount?.accountBalance | supFraction"></span>
              </div>
              <span class="chevron"></span>
            </div>
          </div>

          <ul *ngIf="accounts" class="account-dropdown" [hidden]="!showList">
            <ng-container *ngFor="let account of accounts">
              <li (click)="onAccountChange(account)">
                <div class="account">
                  <div class="float-left account-info text-nowrap">
                    <span class="account-name">{{
                      account.alias || account.description || account.accountName
                      }}</span>
                    <span class="account-number">{{ account?.accountNumber }}</span>
                    <span class="portfolio-name">{{ account?.accountOwner }}</span>
                  </div>

                  <div class="float-right text-right">
                    <div class="balance">
                      {{ account.accountCurrency | abCurrencySymbol }}
                      <span [innerHTML]="account.accountBalance"></span>
                    </div>
                  </div>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>

        <form [formGroup]="categoryForm" class="row">
          <div class="col-md-6" *ngIf="showCategory">
              <label>Transaction category</label>
              <mat-form-field class="d-block ab-select form-control-custom" [floatLabel]="'never'" hideRequiredMarker>
                <mat-select formControlName="category" (selectionChange)="selectCategory()" placeholder="Select category">
                  <mat-option *ngFor="let category of referenceCodes" [value]="category" [attr.title]="category.category">
                    {{ category.category }}</mat-option>
                </mat-select>
              </mat-form-field>
          </div>
          <div class="col-md-6" *ngIf="referenceCodes">
            <label>&nbsp;</label>
              <mat-form-field class="d-block ab-select form-control-custom" [floatLabel]="'never'" hideRequiredMarker>
                <mat-select formControlName="subCategory" (selectionChange)="selectSubCategory($event)"
                  placeholder="Subcategory">
                  <ng-container *ngIf="category?.value">
                    <mat-option *ngFor="let subcategory of category.value.subcategory" [value]="subcategory"
                      [attr.title]="subcategory.name">{{ subcategory.name }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
          </div>
        </form>

        <div>
          <div>
            <label>
              Description
            </label>
          </div>
          <div class="description fs-16">
            {{ transfer?.description }}
          </div>
        </div>
        <div>
          <button class="btn btn-primary btn-block" (click)="confirmPayment()">Transfer</button>
          <button class="btn btn-link btn-block" (click)="openCancelPayment()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<ng-template #validatePayment>
  <ab-validate-payment [rendering]="rendering" [selectedAccountNumber]="selectedAccount?.accountNumber"
    [selectedReferenceCode]="selectedReferenceCode" [dialogRef]="validatePaymentDialogRef" [transfer]="transfer"
    (setMerchantInfo)="setMerchantInfo.emit($event)" (setPaymentStatus)="setPaymentStatus.emit($event)" [challengeCode]="challengeCode"
    (cancelPayment)="openCancelPayment()" />
</ng-template>

  <ng-template #cancelPayment>
  <div mat-dialog-content class="cancel-payment-dialog">
    <h1 class="popup-title">Do you want to cancel this payment?</h1>
    <p class="popup-description">You can restart the payment at the merchant.</p>
  </div>
  <div mat-dialog-actions class="buttons">
    <button class="btn btn-primary btn-block" 
      (click)="cancelSentooPayment()" 
      [disabled]="isSubmittingCancelPayment">
        Yes, cancel
    </button>
    <button class="btn btn-link btn-block" (click)="closeCancelPaymentDialog()">Stay here</button>
  </div>
</ng-template>